import { useState } from "react"
import { Button, Input } from "@heroui/react"
import classes from "../styles/Teachers.module.scss"
import { useNavigate } from "react-router-dom"
import ArticlesTable from "../components/Tables/ArticlesTable"
import useArticlesSearch from "../hooks/useArticlesSearch"

const Articles = () => {
  const [page, setPage] = useState(0)
  const [searchQuery, setSearchQuery] = useState("")
  const { articles, totalPages, loading } = useArticlesSearch(page, searchQuery)

  const navigate = useNavigate()

  const onNewTeacherClick = () => {
    navigate("/article/new")
  }

  return (
    <div className={classes.root}>
      <div className={classes.actions}>
        <Input
          type="text"
          placeholder="חיפוש"
          className={classes.input}
          value={searchQuery}
          onInput={(e) => setSearchQuery(e.currentTarget.value)}
        />
        <div>
          <Button onClick={onNewTeacherClick}>מאמר חדש</Button>
        </div>
      </div>
      <ArticlesTable
        articles={articles}
        page={page + 1}
        pages={totalPages}
        loading={loading}
        onPageChange={(page) => setPage(page - 1)}
      />
    </div>
  )
}

export default Articles
